import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "l-the-header"
}
const _hoisted_2 = { class: "p-the-header" }
const _hoisted_3 = { class: "p-the-header__col" }
const _hoisted_4 = { class: "p-the-header__primary" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "p-the-header__menu p-the-header__menu--sp"
}
const _hoisted_7 = {
  key: 0,
  class: "p-the-header__right"
}
const _hoisted_8 = { class: "p-the-header__right__inner" }
const _hoisted_9 = { class: "p-the-header__right__actions" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "p-the-header__right__point"
}
const _hoisted_13 = { class: "p-the-header__right__point__inner" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "p-the-header__right__trail" }
const _hoisted_17 = { class: "p-the-header-navi__switch" }
const _hoisted_18 = { class: "p-the-header-navi__switch__button__icon" }
const _hoisted_19 = { class: "p-the-header-navi__switch__button__text" }
const _hoisted_20 = { class: "p-the-header__right__user__icon" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "p-the-header__right__notification p-the-header__right__notification--profile" }
const _hoisted_23 = {
  key: 1,
  class: "p-the-header__menu p-the-header__menu--pc"
}
const _hoisted_24 = { class: "p-modal-header" }
const _hoisted_25 = { class: "p-form-button-group" }
const _hoisted_26 = { class: "p-form-button-group__buttons-main" }
const _hoisted_27 = { class: "p-form-button-group__vertical" }
const _hoisted_28 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderNaviForSpLayout = _resolveComponent("TheHeaderNaviForSpLayout")!
  const _component_IconHeaderCoupon = _resolveComponent("IconHeaderCoupon")!
  const _component_IconHeaderFavorite = _resolveComponent("IconHeaderFavorite")!
  const _component_IconUserRank = _resolveComponent("IconUserRank")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_IconLoop = _resolveComponent("IconLoop")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_TextLabelNewArrivalCount = _resolveComponent("TextLabelNewArrivalCount")!
  const _component_TheHeaderUserNavi = _resolveComponent("TheHeaderUserNavi")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_ModalMain = _resolveComponent("ModalMain")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.stickyHeader)
  }, [
    (_ctx.shownHeaderElement)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isExists(_ctx.shownTopElement))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "p-the-header__header",
                  style: _normalizeStyle({ borderColor: _ctx.colorCode })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["c-common-inner", [_ctx.isWideHeader ? 'p-the-header-inner--admin' : '']]),
                    ref: "lTheHeader"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        (_ctx.isExists('logo'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: '/home/',
                              class: "p-the-header__logo",
                              style: _normalizeStyle(_ctx.serviceLogoStyle)
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLogo(),
                                alt: _ctx.serviceName
                              }, null, 8, _hoisted_5)
                            ], 4))
                          : _createCommentVNode("", true),
                        (_ctx.isExists('spNavi'))
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_TheHeaderNaviForSpLayout, {
                                ref: "spHeaderNavi",
                                "whats-new-unread-count": _ctx.whatsNewUnreadCount,
                                "thanks-point-unread-count": _ctx.thanksPointUnreadCount,
                                "switchs-state": _ctx.switchState,
                                "is-user-admin": _ctx.isUserAdmin,
                                onClickChangeModalState: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal())),
                                point: _ctx.totalPoints
                              }, null, 8, ["whats-new-unread-count", "thanks-point-unread-count", "switchs-state", "is-user-admin", "point"])
                            ], 512)), [
                              [_vShow, _ctx.isSp]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isExists(_ctx.shownRightColumn))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _withDirectives((_openBlock(), _createElementBlock("a", {
                                  href: _ctx.myCouponUrl,
                                  class: "p-the-header__quick-link p-the-header__quick-link--coupon",
                                  style: _normalizeStyle({ '--site-color': _ctx.colorCode })
                                }, [
                                  _createVNode(_component_IconHeaderCoupon, { class: "p-the-header__quick-link__icon" }),
                                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "p-the-header__quick-link__text" }, "マイクーポン", -1))
                                ], 12, _hoisted_10)), [
                                  [_directive_touch, void 0, "tap"]
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("a", {
                                  href: _ctx.favoritesUrl,
                                  class: "p-the-header__quick-link p-the-header__quick-link--favorite",
                                  style: _normalizeStyle({ '--site-color': _ctx.colorCode })
                                }, [
                                  _createVNode(_component_IconHeaderFavorite, { class: "p-the-header__quick-link__icon" }),
                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "p-the-header__quick-link__text" }, "お気に入り", -1))
                                ], 12, _hoisted_11)), [
                                  [_directive_touch, void 0, "tap"]
                                ])
                              ]),
                              (_ctx.showPoint)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, [
                                      (
                          _ctx.isSp &&
                            _ctx.isRankDisplayEnabled &&
                            _ctx.imageResources.rank_image_sp
                        )
                                        ? (_openBlock(), _createBlock(_component_IconUserRank, {
                                            key: 0,
                                            size: 120,
                                            class: "p-the-header__right__point__inner__rank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _ctx.imageResources.rank_image_sp,
                                                alt: ""
                                              }, null, 8, _hoisted_14)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _withDirectives((_openBlock(), _createElementBlock("a", { href: _ctx.pointConfirmationUrl }, [
                                        _createVNode(_component_PointNotation, {
                                          "icon-size": _ctx.isSp ? 16 : 28,
                                          point: _ctx.totalPoints,
                                          "sign-is-exists": false,
                                          "font-size": _ctx.isSp ? 16 : 24,
                                          point_logo: _ctx.imageResources.point_logo
                                        }, null, 8, ["icon-size", "point", "font-size", "point_logo"])
                                      ], 8, _hoisted_15)), [
                                        [_directive_touch, void 0, "tap"]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_16, [
                                _withDirectives(_createElementVNode("div", _hoisted_17, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal())),
                                    class: _normalizeClass(["p-the-header-navi__switch__button", [
                          `p-the-header-navi__switch__button--${_ctx.colorCode}`
                        ]]),
                                    style: _normalizeStyle({
                          background: _ctx.colorCode,
                          'border-color': _ctx.colorCode
                        }),
                                    onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseoverSwitchButton && _ctx.mouseoverSwitchButton(...args))),
                                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mouseoverSwitchButton(false)))
                                  }, [
                                    _createElementVNode("i", _hoisted_18, [
                                      _createVNode(_component_IconBase, {
                                        width: 22,
                                        height: 21,
                                        "view-box": "0 0 22 21",
                                        "icon-color": _ctx.switchButtonSvg
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_IconLoop)
                                        ]),
                                        _: 1
                                      }, 8, ["icon-color"])
                                    ]),
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.switchButton.text), 1)
                                  ], 38)), [
                                    [_directive_touch, _ctx.mouseoverSwitchButton, "tap"]
                                  ])
                                ], 512), [
                                  [_vShow, _ctx.isUserAdmin && !_ctx.isSp && !_ctx.ssoFlg]
                                ]),
                                (_ctx.isExists('userMenu'))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "p-the-header__right__user",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openHeaderMenu && _ctx.openHeaderMenu(...args)), ["stop"]))
                                    }, [
                                      _createElementVNode("span", _hoisted_20, [
                                        _createVNode(_component_IconUserImage, {
                                          size: 36,
                                          "is-loading": _ctx.isLoading
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.userImage)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: _ctx.userImage,
                                                  alt: _ctx.userInfo.name
                                                }, null, 8, _hoisted_21))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["is-loading"]),
                                        _createElementVNode("span", _hoisted_22, [
                                          (_ctx.totalUnreadCount > 0 && !_ctx.isGroupBudget)
                                            ? (_openBlock(), _createBlock(_component_TextLabelNewArrivalCount, {
                                                key: 0,
                                                count: _ctx.totalUnread
                                              }, null, 8, ["count"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isExists('userMenu'))
                                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createVNode(_component_TheHeaderUserNavi, {
                                        ref: "pcHeaderNavi",
                                        "thanks-point-unread-count": _ctx.thanksPointUnreadCount,
                                        "whats-new-unread-count": _ctx.whatsNewUnreadCount,
                                        onLogout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logout()))
                                      }, null, 8, ["thanks-point-unread-count", "whats-new-unread-count"])
                                    ], 512)), [
                                      [_vShow, !_ctx.isSp]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ], 4))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      (_ctx.switchState)
        ? (_openBlock(), _createBlock(_component_ModalMain, { key: 0 }, {
            head: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("管理画面に切り替える際は一度ログアウトします。 ", -1),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" このページを離れますか？", -1)
            ])),
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_ButtonMain, {
                      type: "button",
                      onClickButton: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleButtonClick(true)))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("OK", -1)
                      ])),
                      _: 1,
                      __: [11]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_ButtonMain, {
                      kind: "cancel",
                      onClickButton: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleButtonClick(false)))
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("キャンセル", -1)
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 4))
}